import { render, staticRenderFns } from "./PageBanner.vue?vue&type=template&id=19a7af0c&scoped=true"
import script from "./PageBanner.vue?vue&type=script&lang=js"
export * from "./PageBanner.vue?vue&type=script&lang=js"
import style0 from "./PageBanner.vue?vue&type=style&index=0&id=19a7af0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a7af0c",
  null
  
)

export default component.exports